import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";
import type {GroupReservationModel} from "../Models/GroupReservationModel";

import {RoomPeopleConfiguration} from "../Models/RoomPeopleConfiguration";

/**
 * Wiadomość, gdy stworzono lub zmieniono rezerwację grupową,
 * lub z service workera (gdy jakiś komponent się zapisze na otrzymywanie tych aktualizacji)
 */
export class SetGroupReservationBasket extends NfComponentGlobalMessage {
    declare serializedGroupReservationModel: any;
    public persistentMessage = true;
    public constructor(sourceComponentId: number|MessageEvent<SetGroupReservationBasket>|null, groupReservationBasket?:GroupReservationModel) {
        super(NfMessageType.SetGroupReservationBasket, arguments.length > 1);
        if(NfMessage.isMessageEvent(sourceComponentId)) {
            Object.assign(this, sourceComponentId.data);
        } else {
            this.sourceComponentId = sourceComponentId;
            if(!groupReservationBasket) {
                throw Error('groupReservationBasket is required');
            }
            this.serializedGroupReservationModel = this.serialize(groupReservationBasket);
        }
    }
    public getGroupReservationModel():GroupReservationModel {
        const deserialized = <GroupReservationModel>this.deserialize(this.serializedGroupReservationModel);
        if(deserialized.reservations) {
            for(let reservation of deserialized.reservations) {
                if(!(reservation.chosenPeopleConfiguration instanceof RoomPeopleConfiguration)
                && typeof(reservation.chosenPeopleConfiguration) == 'object') {
                    Object.setPrototypeOf(reservation.chosenPeopleConfiguration,RoomPeopleConfiguration.prototype);
                }
            }
        }
        return deserialized;
    }
}
NfMessage.creationCallbacks[NfMessageType.SetGroupReservationBasket] = (event) => {
    return new SetGroupReservationBasket(event);
}
